(() => {
  "use strict";

  class DigiProductDetailsModal {

    constructor() {

      this.modal =
        document.querySelector(
          "[data-digi-product-details-modal]"
        );

      if (!this.modal) {
        return;
      }

      this.dialog =
        this.modal.querySelector(
          ".digi-product-details-modal__dialog"
        );

      this.overlay =
        this.modal.querySelector(
          ".digi-product-details-modal__overlay"
        );

      this.closeButtons = [
        ...this.modal.querySelectorAll(
          "[data-digi-product-details-close]"
        )
      ];

      this.title =
        this.modal.querySelector(
          "[data-digi-product-details-title]"
        );

      this.subtitle =
        this.modal.querySelector(
          "[data-digi-product-details-subtitle]"
        );

      this.image =
        this.modal.querySelector(
          "[data-digi-product-details-image]"
        );

      this.tableContainer =
        this.modal.querySelector(
          "[data-digi-product-details-table]"
        );

      this.tableText =
        this.modal.querySelector(
          "[data-digi-product-details-table-text]"
        );

      this.ingredients =
        this.modal.querySelector(
          "[data-digi-product-details-ingredients]"
        );

      this.consumption =
        this.modal.querySelector(
          "[data-digi-product-details-consumption]"
        );

      this.storage =
        this.modal.querySelector(
          "[data-digi-product-details-storage]"
        );

      this.faq =
        this.modal.querySelector(
          "[data-digi-product-details-faq]"
        );

      this.infoGroups = {
        ingredients:
          this.modal.querySelector(
            '[data-group="ingredients"]'
          ),

        consumption:
          this.modal.querySelector(
            '[data-group="consumption"]'
          ),

        storage:
          this.modal.querySelector(
            '[data-group="storage"]'
          )
      };

      this.tabs = [
        ...this.modal.querySelectorAll(
          ".digi-product-details-modal__tab"
        )
      ];

      this.panels = [
        ...this.modal.querySelectorAll(
          ".digi-product-details-modal__panel"
        )
      ];

      this.subscribeButton =
        this.modal.querySelector(
          "[data-digi-product-details-subscribe]"
        );

      this.activeProduct = null;

      this.lastFocusedElement = null;

      this.handleDocumentClick =
        this.handleDocumentClick.bind(this);

      this.handleKeydown =
        this.handleKeydown.bind(this);

      this.handleTabClick =
        this.handleTabClick.bind(this);

      this.handleClose =
        this.handleClose.bind(this);

      this.init();

    }

    /* =====================================================
       EVENTS
    ===================================================== */

    handleDocumentClick(event) {

      const trigger =
        event.target.closest(
          "[data-digi-product-details-trigger]"
        );

      if (!trigger) {
        return;
      }

      event.preventDefault();

    const card = trigger.closest(
    "[data-digi-product-details-source]"
    );

      if (!card) {
        return;
      }

      this.open(card);

    }

    handleClose() {

      this.close();

    }

    handleTabClick(event) {

      const tab =
        event.currentTarget;

      this.activateTab(
        tab.dataset.tab
      );

    }

    /* =====================================================
       OPEN
    ===================================================== */

    open(card) {

      const json =
        card.querySelector(
          "[data-digi-product-details-json]"
        );

      if (!json) {
        return;
      }

      try{

        this.activeProduct =
          JSON.parse(
            json.textContent
          );

      }catch(error){

        console.error(
          "[Digi Product Details]",
          error
        );

        return;

      }

      this.lastFocusedElement =
        document.activeElement;

        this.populate();

        const firstVisibleTab =
        this.tabs.find(
            tab => !tab.hidden
        );

        if (firstVisibleTab) {

        this.activateTab(
            firstVisibleTab.dataset.tab
        );

        }

      this.modal.hidden = false;

      requestAnimationFrame(()=>{

        this.modal.classList.add(
          "is-open"
        );

      });

      document.documentElement.style
        .overflow = "hidden";

      document.body.style
        .overflow = "hidden";

    }


    /* =====================================================
       POPULATE
    ===================================================== */

    populate() {

    if (!this.activeProduct) {
        return;
    }

    this.populateHeader();

    this.renderNutrition();

    this.renderInformation();

    this.renderFaq();

    this.updateVisibleTabs();

    }

    populateHeader() {

      const product =
        this.activeProduct;

      this.title.textContent =
        product.title || "";

      if(
        product.subtitle
      ){

        this.subtitle.hidden =
          false;

        this.subtitle.textContent =
          product.subtitle;

      }else{

        this.subtitle.hidden =
          true;

        this.subtitle.textContent =
          "";

      }

      if(
        product.image
      ){

        this.image.src =
          product.image;

        this.image.alt =
          product.title || "";

      }

    }

    /* =====================================================
       TABS
    ===================================================== */

    activateTab(name){

      this.tabs.forEach(tab=>{

        const active =
          tab.dataset.tab === name;

        tab.classList.toggle(
          "is-active",
          active
        );

        tab.setAttribute(
          "aria-selected",
          active
            ? "true"
            : "false"
        );

      });

      this.panels.forEach(panel=>{

        panel.classList.toggle(
          "is-active",
          panel.dataset.panel ===
          name
        );

      });

    }

    /* =====================================================
       NUTRITION
    ===================================================== */

    renderNutrition() {

      const product =
        this.activeProduct;

      this.tableContainer.innerHTML = "";

      this.tableText.innerHTML = "";

      const nutrition =
        product.nutrition;

      if (
        nutrition &&
        nutrition.headers &&
        nutrition.data
      ) {

        const table =
          document.createElement(
            "table"
          );

        const thead =
          document.createElement(
            "thead"
          );

        const tbody =
          document.createElement(
            "tbody"
          );

        const headerRow =
          document.createElement(
            "tr"
          );

        nutrition.headers.forEach(
          header => {

            const th =
              document.createElement(
                "th"
              );

            th.textContent =
              header;

            headerRow.appendChild(
              th
            );

          }
        );

        thead.appendChild(
          headerRow
        );

        nutrition.data.forEach(
          row => {

            const tr =
              document.createElement(
                "tr"
              );

            row.forEach(
              column => {

                const td =
                  document.createElement(
                    "td"
                  );

                td.textContent =
                  column;

                tr.appendChild(
                  td
                );

              }
            );

            tbody.appendChild(
              tr
            );

          }
        );

        table.appendChild(
          thead
        );

        table.appendChild(
          tbody
        );

        this.tableContainer.appendChild(
          table
        );

      }

      if (
        product.nutritionText
      ) {

        this.tableText.hidden =
          false;

        this.tableText.innerHTML =
          product.nutritionText;

      } else {

        this.tableText.hidden =
          true;

      }

    }

    /* =====================================================
       INFORMATION
    ===================================================== */

    renderInformation() {

      const product =
        this.activeProduct;

      this.renderInfoGroup(
        this.infoGroups.ingredients,
        this.ingredients,
        product.ingredients
      );

      this.renderInfoGroup(
        this.infoGroups.consumption,
        this.consumption,
        product.consumption
      );

      this.renderInfoGroup(
        this.infoGroups.storage,
        this.storage,
        product.storage
      );

    }

    renderInfoGroup(
      wrapper,
      container,
      value
    ) {

      if (
        value &&
        String(value).trim() !== ""
      ) {

        wrapper.hidden =
          false;

        container.innerHTML =
          value;

      } else {

        wrapper.hidden =
          true;

        container.innerHTML =
          "";

      }

    }

    /* =====================================================
       FAQ
    ===================================================== */

    renderFaq() {

    const product =
    this.activeProduct;

    this.faq.innerHTML = "";

    const faq =
    product.faq;

    if (
    !Array.isArray(faq) ||
    faq.length === 0
    ) {
    return;
    }

        for (let i = 0; i < faq.length; i += 2) {

            const question =
                faq[i];

            const answer =
                faq[i + 1];

            if (!question || !answer) {
                continue;
            }

            const details =
                document.createElement(
                "details"
                );

            const summary =
                document.createElement(
                "summary"
                );

            summary.textContent =
                question;

            const content =
                document.createElement(
                "div"
                );

            content.className =
                "digi-product-details-modal__faq-content";

            content.innerHTML =
                answer;

            details.appendChild(
                summary
            );

            details.appendChild(
                content
            );

            this.faq.appendChild(
                details
            );

        }
    }

    /* =====================================================
       TAB VISIBILITY
    ===================================================== */

    updateVisibleTabs() {

      const hasNutrition =
        this.tableContainer.children.length > 0 ||
        !this.tableText.hidden;

      const hasInfo =
        !this.infoGroups.ingredients.hidden ||
        !this.infoGroups.consumption.hidden ||
        !this.infoGroups.storage.hidden;

      const hasFaq =
        this.faq.children.length > 0;

      this.toggleTab(
        "nutrition",
        hasNutrition
      );

      this.toggleTab(
        "info",
        hasInfo
      );

      this.toggleTab(
        "faq",
        hasFaq
      );

    }

    toggleTab(
      name,
      visible
    ) {

      const tab =
        this.tabs.find(
          item =>
            item.dataset.tab ===
            name
        );

      const panel =
        this.panels.find(
          item =>
            item.dataset.panel ===
            name
        );

      if (tab) {

        tab.hidden =
          !visible;

      }

      if (panel) {

        panel.hidden =
          !visible;

      }

    }

        /* =====================================================
       SUBSCRIBE
    ===================================================== */

    bindSubscribeButton() {

      if (!this.subscribeButton) {
        return;
      }

      this.subscribeButton.addEventListener(
        "click",
        () => {

          if (!this.activeProduct) {
            return;
          }

          document.dispatchEvent(
            new CustomEvent(
              "digi:product-details:subscribe",
              {
                detail: {
                  product: this.activeProduct
                }
              }
            )
          );

          this.close();

        }
      );

    }

    /* =====================================================
       FOCUS TRAP
    ===================================================== */

    handleKeydown(event) {

      if (
        !this.modal.classList.contains(
          "is-open"
        )
      ) {
        return;
      }

      if (event.key === "Escape") {

        event.preventDefault();

        this.close();

        return;

      }

      if (event.key !== "Tab") {
        return;
      }

      const focusable = [
        ...this.modal.querySelectorAll(
          `
          button:not([hidden]),
          [href],
          input,
          select,
          textarea,
          [tabindex]:not([tabindex="-1"])
          `
        )
      ].filter(
        element =>
          !element.disabled
      );

      if (!focusable.length) {
        return;
      }

      const first =
        focusable[0];

      const last =
        focusable[
          focusable.length - 1
        ];

      if (
        event.shiftKey &&
        document.activeElement === first
      ) {

        event.preventDefault();

        last.focus();

      }

      if (
        !event.shiftKey &&
        document.activeElement === last
      ) {

        event.preventDefault();

        first.focus();

      }

    }

    /* =====================================================
       RESET
    ===================================================== */

    reset() {

      this.tableContainer.innerHTML = "";

      this.tableText.innerHTML = "";

      this.ingredients.innerHTML = "";

      this.consumption.innerHTML = "";

      this.storage.innerHTML = "";

      this.faq.innerHTML = "";

      this.title.textContent = "";

      this.subtitle.textContent = "";

      this.subtitle.hidden = true;

      this.image.removeAttribute(
        "src"
      );

      this.image.removeAttribute(
        "alt"
      );

      Object.values(
        this.infoGroups
      ).forEach(group => {

        group.hidden = true;

      });

    }

    /* =====================================================
       CLOSE
    ===================================================== */

    close() {

      this.modal.classList.remove(
        "is-open"
      );

      window.setTimeout(() => {

        this.modal.hidden = true;

        this.reset();

      },300);

      document.documentElement.style
        .overflow = "";

      document.body.style
        .overflow = "";

      if (
        this.lastFocusedElement
      ) {

        this.lastFocusedElement.focus();

      }

    }

    /* =====================================================
       THEME EDITOR
    ===================================================== */

    onThemeEditorSelect() {

      this.close();

    }

    /* =====================================================
       INIT
    ===================================================== */

    init() {

      document.addEventListener(
        "click",
        this.handleDocumentClick
      );

      document.addEventListener(
        "keydown",
        this.handleKeydown
      );

      this.closeButtons.forEach(
        button => {

          button.addEventListener(
            "click",
            this.handleClose
          );

        }
      );

      this.tabs.forEach(
        tab => {

          tab.addEventListener(
            "click",
            this.handleTabClick
          );

        }
      );

      this.bindSubscribeButton();

      document.addEventListener(
        "shopify:section:load",
        () => this.close()
      );

      document.addEventListener(
        "shopify:section:unload",
        () => this.close()
      );

      document.addEventListener(
        "shopify:block:select",
        () => this.onThemeEditorSelect()
      );

    }

  }

  new DigiProductDetailsModal();

})();